/**
 * bundle-builder.js 
 * =============================================================================
 */

var BundleBuilder = {

  data: {
    selectors: {
      add_to_bundle: "[data-bundle-add-to-bundle]",
      bundle_panel_loading: '[data-bundle-loading]',
      bundle_panel_no_items: '[data-bundle-no-items]',
      bundle_panel_some_items: '[data-bundle-some-items]',
      bundle_panel_items: '[data-bundle-items]',
      bundle_price_total: '[data-bundle-current-value]',
      bundle_item_cross: '.bundle-item-cross',
      bundle_add_to_bag: '[data-bundle-add-to-bag]'
    },

    bundle: {
      contents: []
    },

    threshold: null,
    localStorageKey: null,
    swiper: null,
  },

  templates: {
    bundle_item: null
  },

  init: function() {
    if(!MP.Utilities.isBundleBuilderPage()){
      return;
    }

    let that = this;

    // Set suffix to collection handle, and compile templates
    let bundleSuffix = document.body.id;
    this.data.localStorageKey = 'bundle-' + bundleSuffix;
    this.templates.bundle_item =  _.template(document.querySelector("#mp-template-tile-bundle-item").innerText);

    // Check if we have previous bundle data. If so, hydrate it. If not, create it.
    document.querySelector(this.data.selectors.bundle_panel_loading).classList.add('d-none');
    if(!localStorage.getItem(this.data.localStorageKey)) {
      this.initialiseBundle();
    } else {
      this.data.bundle = JSON.parse(localStorage.getItem(this.data.localStorageKey));
      if(this.data.bundle.contents.length == 0){
        this.initialiseBundle();
      } else {
        this.hydrateBundle();
      }
    }

    // Listen for events on the document (because the items are dynamically
    // added to the DOM) and proxy clicks based on the targets.
    document.addEventListener("click", function(e){
      if(e.target.matches(that.data.selectors.add_to_bundle)){
        that.handleAddToBundle(e);
      }
      else if(e.target.closest(that.data.selectors.bundle_item_cross)){
        that.handleDeleteFromBundle(e);
      }
      else if(e.target.matches(that.data.selectors.bundle_add_to_bag)){
        that.handleAddBundleToCart(e)
      }
    });

    document.querySelector(".bundle-bar").style.opacity = 1;
  },

  /**
   * Display 'no bundle' information and initalise in localStorage
   */
  initialiseBundle: function() {
    localStorage.setItem(this.data.localStorageKey, JSON.stringify(this.data.bundle));
    document.querySelectorAll(this.data.selectors.bundle_panel_no_items).forEach(element => {
      element.style.setProperty("display", "")
    });
    document.querySelectorAll(this.data.selectors.bundle_panel_some_items).forEach(element => {
      element.style.setProperty("display", "none", "important");
    });
  },

  /**
   * Populate & display bundle information from localStorage
   */
  hydrateBundle: function() {
    this.data.bundle = JSON.parse(localStorage.getItem(this.data.localStorageKey));
    document.querySelectorAll(this.data.selectors.bundle_panel_no_items).forEach(element => {
      element.style.setProperty("display", "none", "important");
    });
    document.querySelectorAll(this.data.selectors.bundle_panel_some_items).forEach(element => {
      element.style.setProperty("display", "");
    });
    this.render();
  },

  /**
   * Add the bundle to the cart
   * @param  Event e the event object
   * @return null
   */
  handleAddBundleToCart: function(e) {
    let items = [];

    // Legacy, from the original bundle builder. Keeping to prevent any issues.
    let properties = {
      "Product bundle": "This product is part of bundle #" + Math.floor(Math.random() * (99999 - 9999) + 9999),
      "_product_bundle_key": Math.floor(Math.random() * (99999 - 9999) + 9999)
    }

    this.data.bundle.contents.forEach(function(elem) {
      let existingIndex = items.findIndex(item => item.id == elem.variant_id);
      if(existingIndex > -1){
        items[existingIndex].quantity += 1;
      } else {
        let item = {
          id: elem.variant_id,
          quantity: 1,
          properties: properties
        };
        items.push(item);
      }
    });

    // Add the medium gift box as well - see https://3.basecamp.com/3537797/buckets/15146339/todos/4148407064#__recording_4376196821
    // Now updated - see https://3.basecamp.com/3537797/buckets/15146339/card_tables/cards/6693760511#__recording_7102286744
    let giftBox = {
      id: 40952930140227,
      quantity: 1,
      properties: properties
    };
    items.push(giftBox);

    window.disableNextMinicartOpen = true;
    MP.Extensions.Cart.add(items).then(this.handleAddedBundleToCart.bind(this));
  },

  /**
   * Add the bundle cart attribute
   * @param {Event} e 
   */
  handleAddedBundleToCart: function(e) {
    const config = MP.Utilities.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({ "attributes": { 'Has Bundle': 'Yes' }});

    const fetchPromise = fetch(`${routes.cart_update_url}`, config).then(response => response.json());
    fetchPromise.then(this.handleAddedCartNoteAfterBundle.bind(this));

    return fetchPromise;
  },

  /**
   * Take the user to the cart
   * @param {Event} e 
   */
  handleAddedCartNoteAfterBundle: function(e) {
    this.data.bundle.contents = [];
    this.commitToStorage();
    window.location = '/cart';
  },

  /**
   * Add an item to the bundle
   * @param Event e the event object
   * @return null
   */
  handleAddToBundle: function(e) {
    var that = this;
    var target = e.target;
    var parentProduct = target.closest('[data-variant-id]');

    console.log("[BB] this", this);
    console.log("[BB] target", target);
    console.log("[BB] parentProduct", parentProduct);

    // Populate the item from data attributes on parent element
    var bundleItem = {
      variant_id: parentProduct.dataset.variantId,
      image: parentProduct.dataset.variantImage,
      price: parentProduct.dataset.variantPrice,
      title: parentProduct.dataset.variantTitle,
      id: Math.floor(Math.random() * (9999 - 1000) + 1000)
    };

    // First item? Show the 'some items' panels
    if(this.data.bundle.contents.length == 0) {
      document.querySelectorAll(this.data.selectors.bundle_panel_no_items).forEach(element => {
        element.style.setProperty("display", "")
      });
      document.querySelectorAll(that.data.selectors.bundle_panel_some_items).forEach(element => {
        element.style.setProperty("display", "none", "important");
      });
    }

    // Add item to slider, and to localStorage
    this.data.bundle.contents.push(bundleItem);
    this.commitToStorage();
    this.render();
  },

  /**
   * Remove an item from the bundle (visually, and in storage)
   * @param  Event e the event object
   * @return null
   */
  handleDeleteFromBundle: function(e) {
    let bundleItem = e.target.closest('[data-bundle-item-variant-id]');
    let idToDelete = bundleItem.dataset.bundleItemId;

    // Remove from bundle data
    this.data.bundle.contents = this.data.bundle.contents.filter(function(elem) {
      return elem.id != idToDelete;
    });
    
    this.commitToStorage();
    this.render();
  },

  /**
   * Render the bundle panel based on the current state
   * @return null
   */
  render: function() {
    var that = this;


    // Update slider
    this.swiper.removeAllSlides();
    this.data.bundle.contents.forEach(function(elem){
      var templateData = {
        title: elem.title,
        price: MP.Utilities.formatMoney(elem.price, theme.moneyFormat),
        img_src:  elem.image,
        id: elem.id,
        variant_id: elem.variant_id
      };
      that.swiper.appendSlide(`<div class='swiper-slide'>${that.templates.bundle_item(templateData)}</div>`);
    });

    // Update visual total
    var total = MP.Utilities.formatMoney(this.getTotal(), theme.moneyFormat);
    document.querySelectorAll(this.data.selectors.bundle_price_total).forEach(element => {
      element.innerText = total;
    });

    // Update buttons if threshold reached / not reached
    if(this.getTotal() >= this.data.threshold) {
      document.querySelectorAll('[data-bundle-not-enough-items]').forEach(element => {
        element.classList.add("d-none");
      });
      document.querySelectorAll('[data-bundle-enough-items]').forEach(element => {
        element.classList.remove("d-none");
      });

    } else {
      document.querySelectorAll('[data-bundle-not-enough-items]').forEach(element => {
        element.classList.remove("d-none");
      });
      document.querySelectorAll('[data-bundle-enough-items]').forEach(element => {
        element.classList.add("d-none");
      });
    }

    // Update visual count
    //document.querySelector('[data-bundle-count]').innerText = this.data.bundle.contents.length;

    // If down to 0 items, toggle to 0 item state
    if(this.data.bundle.contents.length == 0) {
      document.querySelectorAll(this.data.selectors.bundle_panel_no_items).forEach(element => {
        element.style.setProperty("display", "")
      });
      document.querySelectorAll(that.data.selectors.bundle_panel_some_items).forEach(element => {
        element.style.setProperty("display", "none", "important");
      });
    } else {
      document.querySelectorAll(this.data.selectors.bundle_panel_no_items).forEach(element => {
        element.style.setProperty("display", "none", "important");

      });
      document.querySelectorAll(that.data.selectors.bundle_panel_some_items).forEach(element => {
        element.style.setProperty("display", "")
      });
    }

    this.swiper.slideTo(this.swiper.slides.length);
  },

  /**
   * Get the total price of all items in the bundle (unformatted)
   * @return int The total price
   */
  getTotal: function() {
    return this.data.bundle.contents.reduce(function(acc, elem) {
      return acc + parseInt(elem.price)
    }, 0);
  },

  /**
   * Store the current bundle in localStorage
   * @return null
   */
  commitToStorage: function() {
    localStorage.setItem(this.data.localStorageKey, JSON.stringify(this.data.bundle));
  }

};

export default BundleBuilder;